import React, { useEffect, useState } from "react";
import useWindowWidth from "../../../../../hooks/useWindowWidth";
import PlaceholderImage from "../../../assets/placeholder.jpg";
import searchIcon from "../../../../../assets/img/top-selling.png";
import { Skeleton } from "@mui/material";

import axiosProtected from "../../../../../api/config/baseWithToken";
import NewNotFound from "../../../components/NewNotFound";

export default function TopSellingProducts({ products, globalLoading, storeOwner }) {
  const windowWidth = useWindowWidth();

  const [topSellingProducts, setTopSellingProducts] = useState(null);
  const [loading, setLoading] = useState(false);
  const getTop3SellingProducts = async () => {
    try {
      setLoading(true)
      await new Promise(resolve => setTimeout(resolve, 1000));
      const { data } = await axiosProtected.get("/store/top-selling-products");
      setTopSellingProducts(data?.result);
    } catch (error) {
      console.log(error);
    }finally{
      setLoading(false)
    }
  };

  useEffect(() => {
    if(!storeOwner){

      getTop3SellingProducts();
    }
  }, []);

  const mappedProducts = loading ? [1, 2, 3] : topSellingProducts;
  return (
    <div
      style={{
        marginTop: "20px",
        padding: windowWidth <= 1500 ? "10px" : "20px 25px",
        height: topSellingProducts?.length > 0 ? "320px" : "400px",
        boxShadow: "rgba(17, 17, 26, 0.1) 0px 0px 16px",
        borderRadius: "8px",
      }}
    >
      <h4 style={{ fontSize: windowWidth <= 1500 ? "16px" : "18px" }}>
        Top Selling Products
      </h4>
      {mappedProducts?.length > 0 ? (
        mappedProducts?.map((item) => (
          <div
            key={item.id}
            style={{
              display: "flex",
              alignItems: "center",
              marginTop: windowWidth <= 1500 ? "0px" : "5px",
            }}
          >
            {loading ? (
              <Skeleton
                variant="rounded"
                width={50}
                height={50}
                sx={{ marginRight: "5px", marginTop: "20px" }}
              />
            ) : (
              <img
                src={
                  item?.details?.variant_image
                    ? item?.details?.variant_image
                    : PlaceholderImage
                }
                alt="product"
                style={{
                  width: windowWidth <= 1500 ? "35px" : "45px",
                  height: windowWidth <= 1500 ? "35px" : "45px",
                  objectFit: "contain",
                  marginRight: windowWidth <= 1500 ? "5px" : "10px",
                  borderRadius: "8px",
                }}
              />
            )}
            {loading ? (
              <Skeleton
                variant="rounded"
                height={50}
                width="100%"
                sx={{ marginTop: "20px" }}
              />
            ) : (
              <div>
                <h6
                  style={{
                    fontSize: windowWidth <= 1500 ? "11px" : "12px",
                    lineHeight: 1.5,
                    marginBottom: 10,
                    marginTop: 10,
                  }}
                >
                  {item?.details?.product_title || "N/A"}
                </h6>
                <h6
                  style={{
                    marginTop: 0,
                    fontWeight: 500,
                    fontSize: windowWidth <= 1500 ? "11px" : "",
                  }}
                >
                  {item?.count} pieces
                </h6>
              </div>
            )}
          </div>
        ))
      ) : (
        <NewNotFound
          title=" No Top-Selling products"
          subTitle="We didn't find any sales data yet."
          img={searchIcon}
          topSelling={true}
        />
      )}
    </div>
  );
}
